import React from 'react';

class ConversationMessageInformer extends React.Component {
  constructor (props) {
    super(props);

    this.state = {};
  }

  render () {
    const content = this.props.message || this.props.children

    return (
      <div className='conversation-message-informer'>
        <div className='conversation-seperator-helper'>
          {content}
        </div>
      </div>
    )
  }
}

export default ConversationMessageInformer;



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/conversation_message_informer.js
 **/